import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL_SERVICE } from '../../kiene-core.config';
import { PdfViewerInput } from './kiene-pdf-viewer/classes/pdf-viewer-input';
import { KieneBackendApiService } from '../../services/backend-api/kiene-backend-api.service';

@Injectable({ providedIn: 'root' })
export class EmailService {
    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private apiService: KieneBackendApiService,
    ) {}

    sendEmail(kieneMail: PdfViewerInput) {
        console.log('INPUT: ', kieneMail);
        return this.apiService.post(this.apiBaseUrl + kieneMail.url, kieneMail, kieneMail.params);
    }
}
